import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import type { State } from 'state';
import { closeChatSideBar, openChatSideBar } from 'state/actions/chat-details';
import { isChatSideBarOpen as isChatSideBarOpenSelector } from 'state/selectors/chat-details';
import { getCanAdministerProject, getProjectId } from 'state/selectors/portal';
import { getCanAdministerJIRA } from 'state/selectors/user';
import { getPortalIdAsNumber } from 'view/search/common';
import { VirtualServiceAgentHeaderDumb } from '../virtual-service-agent-header-dumb';

const selector = createSelector(
    (state: State, { portalId }: { portalId: string }) => {
        const isJiraAdmin = Boolean(getCanAdministerJIRA(state));
        const projectId = portalId && getProjectId(state, getPortalIdAsNumber(portalId));
        const isChatSideBarOpen = isChatSideBarOpenSelector(state);
        const isProjectAdmin = getCanAdministerProject(state, getPortalIdAsNumber(portalId));
        return {
            isJiraAdmin,
            projectId,
            isChatSideBarOpen,
            isProjectAdmin,
        };
    },
    ({ isJiraAdmin, projectId, isChatSideBarOpen, isProjectAdmin }) => ({
        isJiraAdmin,
        projectId,
        isChatSideBarOpen,
        isProjectAdmin,
    })
);
const mapDispatchToProps = {
    openChatSideBar,
    closeChatSideBar,
};
export default connect(selector, mapDispatchToProps)(VirtualServiceAgentHeaderDumb);
